import BaseFragmentSerializer from '@square/dashboard-data/serializers/fragment';
export default BaseFragmentSerializer.extend({
  /**
   * Workaround for the pricing fragment not supporting relationships
   * like hasMany for discounts. Instead, we have to manually attach the
   * correct discounts based on IDs, and remove them when serializing.
   */
  serializeAttribute(snapshot, json, key, attribute) {
    if (key === 'discounts') {
      return;
    }
    this._super(snapshot, json, key, attribute);
  }
});